import { render } from "./selldetail.vue?vue&type=template&id=7a8693d8&scoped=true"
import script from "./selldetail.vue?vue&type=script&lang=js"
export * from "./selldetail.vue?vue&type=script&lang=js"

import "./selldetail.vue?vue&type=style&index=0&id=7a8693d8&scoped=true&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8693d8"]])

export default __exports__